import './../../Player.css';
import React, {useContext, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Image} from 'react-native';
import { PlayerContext } from '../../PlayerContext';
import { lighterColor } from '../../Utils';
import { useAnimate } from 'framer-motion';
import { setStoryClicked1Time } from '../../Player';
import { ButtonBase, styled } from '@mui/material';

export const hoursType = "hours";
export const reviewsType = "reviews";
export const locationType = "location";
export const shareType = "share";
export const chatType = "chat";
export const nearType = "near";
export const influencerType = "influencer";
export const promoType = "promo";

function SecondaryButton(props){
    const { t } = useTranslation();
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const propagateFocusChange = useContext(PlayerContext).get("propagateFocusChange");
    const primaryColor = useContext(PlayerContext).get("primaryColor");
    const highlight = useContext(PlayerContext).get("highlight");
    const setHighlight = useContext(PlayerContext).get("setHighlight");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier"); 
    const setPlayInteractiveAnimation = useContext(PlayerContext).get("setPlayInteractiveAnimation");
    const [scope, animate] = useAnimate();

    const activeFeature = useContext(PlayerContext).get("activeFeature");
    const hiddenByDialog = activeFeature != null
        && activeFeature !== props.buttonType;

    let icon = "#";
    let x = storyDimensions.containerWidth + (- 36 - 8 - 8 ) * sizeMultiplier;
    let y = 0;
    
    let buttonText = "";
    const imgAdditionalStyle = {};
    const buttonAdditionalStyle = {};
    switch (props.buttonType){
        case hoursType: 
            icon = "/images/ic_access_time.png";        
            y = storyDimensions.containerHeight + (- 8 - 38 - 8 - 38 - 32 - 36 - 16 - 36) * sizeMultiplier;
            buttonText = t("Hours").toLowerCase();
            break;
        case reviewsType: 
            icon = "/images/ic_star.png";            
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36 - 16 + (props.story.premium ? (- 36 - 16) : 0) - 36  + (props.story && props.story.nearbyAttractions ?  (- 16 - 36) :0)) * sizeMultiplier;            
            buttonText = t("Reviews");
            break;
        case locationType: 
            icon = "/images/ic_location_on.png";
            y = storyDimensions.containerHeight + (- 8 - 38 - 8 - 38 - 32 - 36) * sizeMultiplier;
            buttonText = t("Location");
            break;
        case shareType: 
            icon = "/images/ic_share_white.png";
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36) * sizeMultiplier;
            buttonText = t("ShareButton");
            break;
        case chatType: 
            icon = "/images/ic_chat.png";
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36 - 16 - 36) * sizeMultiplier;
            buttonText = t("ChatButton");
            break;
        case nearType: 
            icon = "/images/ic_attraction.png";
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36 - 16  + (props.story.premium ? (- 36 - 16) : 0) - 36) * sizeMultiplier;
            buttonText = t("NearButton");
            break;
        case influencerType: 
            icon = props.story.influencerAvatar;
            imgAdditionalStyle.width = 40 * sizeMultiplier;
            imgAdditionalStyle.height = 40 * sizeMultiplier;
            imgAdditionalStyle.borderRadius = '50%';
            imgAdditionalStyle.objectFit = 'cover';
            buttonAdditionalStyle.height = 60 * sizeMultiplier;
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36 - 16 + (props.story.premium ? (- 36 - 16) : 0) + (props.story.premium ? (- 36 - 16) : 0)  + (props.story && props.story.nearbyAttractions ?  (- 16 - 36) :0) + (props.story && props.story.promoType ?  (- 16 - 36) :0) - 52) * sizeMultiplier;
            buttonText = t("InfluencerButton");
            break;
        case promoType: 
            icon = "/images/ic_promo.png";
            y = storyDimensions.containerHeight + (- 24 - 32 - 24 - 36 - 16 + (props.story.premium ? (- 36 - 16) : 0) + (props.story.premium ? (- 36 - 16) : 0) + (props.story && props.story.nearbyAttractions ?  (- 16 - 36) :0) - 36) * sizeMultiplier;
            buttonText = t("PromoButton");
            break;
        default:
            break;
    }

    useEffect(() => {
        if (highlight != null){
            
            let elementId = null;
            if (highlight.includes("hours") && props.buttonType === hoursType){
                elementId = "secondary-btn-hours";                    
            }
            else if (highlight.includes("reviews") && props.buttonType === reviewsType){                
                elementId = "secondary-btn-reviews";                
            }
            else if (highlight.includes("location") && props.buttonType === locationType){
                elementId = "secondary-btn-location";
            }
            else if (highlight.includes("share") && props.buttonType === shareType){
                elementId = "secondary-btn-share";
            }

            const element = document.getElementById(elementId);
            if (elementId != null && element != null){                
                const animation = async () => {                    
                    await animate(element, { background: "#FFFFFFFF"}, {duration: 0.6});
                    if (element != null)
                        animate(element, { background: "#FFFFFF00"}, {duration: 0.6});                    
                }                
                animation();
            }
        }
      }, [highlight]);

    function open(e){
        e.stopPropagation();
        setStoryClicked1Time(true);
        setPlayInteractiveAnimation(false);
        props.open();
    }

    // TODO click zone to 40
    
    const RoundButton = styled(ButtonBase)(({ theme }) => ({
        color: props.color,
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: "#FFFFFF80", 
        },
    }));

    // Pour teinter l'icône avec la couleur si c'est promoType
    const shouldTintIcon = props.buttonType === promoType && props.color;
    const iconWrapperStyle = shouldTintIcon ? {
        width: 24 * sizeMultiplier,
        height: 24 * sizeMultiplier,
        backgroundColor: props.color,
        maskImage: `url(${icon})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${icon})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        ...imgAdditionalStyle
    } : null;

    return (
        <RoundButton ref={scope} id={"secondary-btn-"+props.buttonType} name={"secondary-btn-"+props.buttonType} sx={{position: "absolute", zIndex: 10, color: 'white', borderRadius: 18, width: 44 * sizeMultiplier, height: 44 * sizeMultiplier, left: x, top: y, cursor: "pointer", display: 'flex', flexDirection: 'column', alignItems: 'center', visibility: hiddenByDialog ? 'hidden' : 'visible', pointerEvents: hiddenByDialog ? 'none' : 'auto', ...buttonAdditionalStyle}} onClick={open} aria-hidden={hiddenByDialog}>  
            {shouldTintIcon ? (
                <div aria-hidden="true" style={iconWrapperStyle} />
            ) : (
                <img alt="" aria-hidden="true" src={icon} loading="eager" decoding="async" style={{width: 24 * sizeMultiplier, height: 24 * sizeMultiplier, pointerEvents: 'none', ...imgAdditionalStyle}} />
            )}
            <div style={{fontSize: 12 * sizeMultiplier, color: shouldTintIcon ? props.color : 'white', fontWeight: props.buttonType === promoType ? 'bold' : 'normal', whiteSpace: 'nowrap'}}>{buttonText}</div>
        </RoundButton>
    );
}

export default SecondaryButton;